module.exports = __webpack_public_path__ + "DINNextLTPro-Light.woff?7a695341453f32a1ab3622c01b17e8ba";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Light.woff
// module id = 1422
// module chunks = 0